import { PricingTable } from "@clerk/clerk-react"
import {
  IonContent,
  IonHeader,
  IonImg,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react"

export function PricingPage() {
  return (
    <IonPage id="main-content">
      <IonHeader>
        <IonToolbar>
          <IonImg
            slot="start"
            src="logo.svg"
            alt="logo"
            style={{ width: "40px", height: "40px", marginLeft: "15px" }}
          ></IonImg>
          <IonTitle>Live Draw</IonTitle>

          {/* <IonButtons slot="end" style={{ marginRight: "15px" }}>
            <Session />
          </IonButtons> */}
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div style={{ padding: "40px" }}>
          <h1>Pricing</h1>
          <PricingTable />
        </div>
      </IonContent>
    </IonPage>
  )
}
